/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { ServerError } from "./dto/error.interfaces";

export enum ActionStatus {
    Initial,
    Working,
    Done,
    Error,
}

export interface ActionHook {
    status: ActionStatus;
    error: string | ServerError[];
}
